import React, { useEffect, useRef, useState } from 'react'
import { Switch, Route, useRouteMatch, useHistory } from 'react-router-dom'
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import theme from './theme'
import { useLocalStorage } from '../../services/hooks/useLocalStorage'
import { getMFPHash } from '../../services/api'
import axios from 'axios'
import Header from '../Header'
import { Toolbar } from './toolbar'
import { PrintJobs } from './print-jobs'
import { PrintSettings } from './print-settings'
// import jwtDecode from 'jwt-decode'
import Loading from '../Loading'
import { getDomain, getSwsDomain } from '../../services/api'
import { STC_ID, STRATUS_ID } from '../../services/constants';

const domain = getDomain() === 'localhost:3000' ? 'stratus.lol' : getDomain()
const defaultPreferences = {
  copies: 1,
  color: '1',
  color_editable: true,
  collate: 'True',
  collate_editable: true,
  offset: 'False',
  offset_editable: true,
  layout: 'NORMAL',
  layout_editable: true,
  binding: 'LEFT',
  binding_editable: true,
  staple: '',
  staple_editable: true,
  fold: '',
  fold_editable: true,
  punch: '',
  punch_editable: true
}

export const Release2MeApp = () => {
  const { path } = useRouteMatch()
  const history = useHistory()
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(true);
  const [user] = useLocalStorage('user', '')
  const [tenant] = useLocalStorage('tenant', undefined)
  const [jwt] = useLocalStorage('accessToken', '')
  const [stratus] = useLocalStorage("stratus", false);
  const [jobs, setJobs] = useState([])
  const [univPrintJobs, setUnivPrintJobs] = useLocalStorage('univPrintJobs', [])
  const [queues, setQueues] = useState([])
  const [optimizedJobs, setOptimizedJobs] = useState([])
  const [selected, setSelected] = useState({})
  const [search, setSearch] = useState('')
  const [distinctQueues, setDistinctQueues] = useState([])
  const [pinnedQueue, setPinnedQueue] = useState({})
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [openPrintSettingsDialog, setOpenPrintSettingsDialog] = useState(false)
  const [keep, setKeep] = useState(false)
  const [userPreferences, setUserPreferences] = useState(defaultPreferences)
  const [overridePreferences, setOverridePreferences] = useState(false)
  const isPrinting = useRef(false)

  // console.log('userPreferences:', userPreferences)

  useEffect(() => {
    refresh()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    console.log('optimizedJobs:', optimizedJobs)
    console.log('SelectedJobs:', selected)
    const handleHardKey = (event) => {
      if (event.keyCode && event.keyCode === 163) {
        // Start button
        const toprint = optimizedJobs.filter((job) => {
          return selected[job.id] !== undefined
        })
        if (toprint.length > 0) printJobs(toprint)
      } else if (event.keyCode && event.keyCode === 164) {
        // Stop button
      }
    }
    document.addEventListener('keydown', handleHardKey)
    return () => document.removeEventListener('keydown', handleHardKey)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optimizedJobs, selected])

  useEffect(() => {
    if (jobs.length > 0 && queues.length > 0) {
      const res = getOptimizedJobs(jobs, queues)
      res.sort((a, b) => (a?.queue?.name.localeCompare(b?.queue?.name, undefined, { sensitivity: 'base' })) || (b.dateCreated - a.dateCreated))
      setOptimizedJobs(res)
      getDistinctQueues(res, queues)
      setIsLoading(false)
    } else {
      setOptimizedJobs([])
      setDistinctQueues([])
    }
  }, [jobs, queues])

  useEffect(() => {
    applySearch(search) // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search])

  useEffect(() => {
    // if km_device.SetLedStartKey not supported, exit
    if (!(typeof window.km_device !== "undefined" && typeof window.km_device.SetLedStartKey !== "undefined")) return
    let appId = STC_ID;
    if (stratus) {
      appId = STRATUS_ID;
    }
    let ledc = 0
    // leds 0 is for solid, 1 for blink fast, 2 for blink slow
    const leds = 0
    if (Object.keys(selected).length > 0) {
      // ledc  1 is for "blue"
      ledc = 1
    }
    try {
      window.km_device.SetLedStartKey(appId, { LedType: ledc, LedState: leds })
    } catch (e) {
      console.log(e)
    }
  }, [selected, stratus])

  // function getUserId(jwt) {
  //   const decodedToken = jwtDecode(jwt)
  //   return decodedToken.sub
  // }

  function setSearchString(s) {
    setSearch(s)
  }

  async function refresh() {
    try {
      if (!isLoading) setIsLoading(true)
      setSelected({})
      await Promise.all([getUserJobs(), getUserQueues(), getUnivPrintJobs()])
      setSearch('')
      setUserPreferences(defaultPreferences)
    } catch (e) {
      setIsLoading(false)
      console.log('Refresh.Error:', e)
    }
    setIsLoading(false)
  }

  function redirectToPrintSettings() {
    history.push('/release2me/settings')
  }

  function applySearch(search = '') {
    if (search.length > 0) {
      const res = getOptimizedJobs(jobs, queues)
      const tmp = res.filter((job) => {
        return job.name.toLowerCase().indexOf(search.toLowerCase()) !== -1
      })
      setOptimizedJobs(tmp)
    } else {
      const res = getOptimizedJobs(jobs, queues)
      setOptimizedJobs(res)
    }
  }

  // new code
  function getDistinctQueues(jobs, queues) {
    let res = []
    if (jobs.length > 0) {
      jobs.forEach((job) => {
        if (res.length === 0) {
          res.push(job.queue.id)
        } else {
          if (res.indexOf(job.queue.id) === -1) {
            res.push(job.queue.id)
          }
        }
      })
    }
    const myQueues = res.map((queueId) => {
      const queue = queues.filter((q) => {
        return queueId === q.id && queueId !== '-1'
      })
      return queue[0]
    })
    if (res.indexOf('-1') !== -1) myQueues.push({ id: '-1', name: 'Delegated To Me Queue', active: true })
    setDistinctQueues(myQueues.filter(item => item))
  }

  function getOptimizedJobs(jobs, queues) {
    const res = jobs.map((job) => {
      const queueId = job.printQueueId
      const queue = queues.filter((q) => {
        return q.id === queueId
      })
      return {
        ...job,
        queue: {
          ...(queue[0] ? queue[0] : { id: '-1', name: 'Delegated To Me Queue', active: true })
        }
      }
    }).filter((j) => {
      return j.queue.active
    })
    return res
  }

  async function getUserJobs() {
    const fetchJobs = async () => {
      try {
        const res = await fetch(
          `https://${tenant.region}.release2me-service.${domain}/api/print-job/get/user`,
          {
            method: 'get',
            headers: {
              'Authorization': `Bearer ${jwt}`
            }
          }
        )
        return await res.json()
      } catch (e) {
        console.error(e)
        return []
      }
    }
    if (jwt && tenant.region) {
      const j = await fetchJobs()
      setJobs(j)
    } else {
      setJobs([])
    }
  }
  async function getUnivPrintJobs() {
    let appId = STC_ID
    if (stratus) {
      appId = STRATUS_ID
    }
    const { hash } = await getMFPHash(appId)
    const fetchJobs = async () => {
      try {
        const res = await fetch(
          `https://${tenant.region}.ms-universal-print.${domain}/api/print-jobs/jobs/${hash}`,
          {
            method: 'get',
            headers: {
              'Authorization': `Bearer ${jwt}`
            }
          }
        )
        return await res.json()
      } catch (e) {
        console.error(e)
        return []
      }
    }
    if (jwt && tenant.region) {
      const j = await fetchJobs()
      const univPrintJobs = j.map(job => {
        return {
          ...job,
          isUnivPrintJob: true
        }
      })
      setUnivPrintJobs(univPrintJobs)
    } else {
      setUnivPrintJobs([])
    }
  }

  async function getUserQueues() {
    const fetchQueues = async () => {
      try {
        const res = await fetch(
          `https://${tenant.region}.release2me-service.${domain}/api/print-queue/get/user`,
          {
            method: 'get',
            headers: {
              'Authorization': `Bearer ${jwt}`
            }
          }
        )
        return await res.json()
      } catch (e) {
        console.error(e)
        return []
      }
    }
    if (jwt && tenant) {
      const q = await fetchQueues()
      setQueues(q)
    } else {
      setQueues([])
    }
  }

  const listDropFiles = async (dropid, username, password) => {
    const s3ApiUrl = `https://${tenant.region}.s3-adapter.${domain}`
    const auth = {
      username: username,
      password: password
    }
    const reqpath = `${s3ApiUrl}/api-1/list/${dropid}`
    const resp = await axios.get(reqpath, { auth: auth })
    return resp.data
  }

  const uploadFile = async (dropid, username, password, filename) => {
    const s3ApiUrl = `https://${tenant.region}.s3-adapter.${domain}`
    const auth = {
      username,
      password
    }
    const reqpath = `${s3ApiUrl}/api-1/link/ul/${dropid}/${filename}`
    const resp = await axios.get(reqpath, { auth })
    return resp
  }

  async function getDropFiles(drop) {
    const obj = await listDropFiles(drop.id, drop.username, drop.password)
    const res = obj.objects.map((file) => {
      return file.name
    })
    return res
  }

  async function releaseUniversalPrintJob(jobId) {
    try {
      let appId = STC_ID
      if (stratus) {
        appId = STRATUS_ID
      }
      const { hash } = await getMFPHash(appId)
      const res = await fetch(
        `https://${tenant.region}.ms-universal-print.${domain}/api/print-jobs/release`,
        {
          method: 'post',
          headers: {
            'Authorization': `Bearer ${jwt}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            jobId: Number(jobId),
            deviceHash: hash
          })
        },
      )
      return await res.json()
    } catch (error) {
      console.error('JobID:', jobId, ' Error: ', error)
    }
  }

  async function printJobs(jobs) {
    if (isPrinting.current) {
      console.log({ Result: 'Already printing' })
      return { Result: 'Already printing' }
    }
    isPrinting.current = true
    try {
      return await runPrintJobs(jobs)
    } finally {
      isPrinting.current = false
    }
  }

  async function runPrintJobs(jobs) {
    const printJob = async (job) => {
      let appId = STC_ID
      if (stratus) {
        appId = STRATUS_ID
      }
      // let temp_AppId = '0A024ADE'

      try {
        const { hash } = await getMFPHash(appId)
        let filename = job.metadata?.[0]?.uuid
        if (!filename) {
          const file = await getDropFiles(job.droppoint)
          if (Array.isArray(file)) {
            // WARNING::this is only the right file when the droppoint holds one job's file - if there
            // are multiple files in the droppoint (like from `r2m-out` using an existing droppoint)
            // there needs to be a `metadata[0].uuid` matching the filename used in the droppoint
            filename = file.filter((item) => !/^pjl(-.+)?\.txt$/.test(item))[0]
          } else {
            filename = file
          }
          console.log('File:', file)
        }
        console.log('Filename:', filename)
        const pjlName = `pjl-${job.id}.txt`
        await uploadPjl(job, pjlName, userPreferences)
        const url = getSwsDomain(tenant.region)
        const response = await fetch(
          `https://${url}/api/device/flops/command`,
          {
            headers: {
              'Authorization': `Bearer ${jwt}`,
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({
              'cmd': 'print_file',
              'thing': `flops_mfp::${appId}::${hash}`,
              'file_drop': `drops://${job.droppoint.username}:${job.droppoint.password}@${tenant.region}.s3-adapter.${domain}/${job.droppoint.id}/${filename}`,
              'pjl_drop': `drops://${job.droppoint.username}:${job.droppoint.password}@${tenant.region}.s3-adapter.${domain}/${job.droppoint.id}/${pjlName}`,
              'cleanup': {
                'print_file': false,
                'header_file': true,
                'referenced_drops': false
              }
            })
          }
        )

        if (!response.ok) {
          throw new Error(`Error printing job ${job.id}: ${response.status}`)
        }
        return job.id
      } catch (e) {
        console.error('JobID:', job.id, ' Error: ', e)
        return '-1'
      }
    }

    if (jobs.length === 0 && univPrintJobs === 0) {
      console.log({ Result: 'Nothing to print' })
      return { Result: 'Nothing to print' }
    }
    if (jobs && jobs.length > 0 && Object.keys(selected).length > 0) {
      const toprint = jobs.filter((job) => {
        return selected[job.id] !== undefined
      })

      let torelease = []
      for (let i = 0; i < toprint.length; i++) {
        const res = await printJob(toprint[i])
        torelease.push(res)
      }

      const toreleaseSuccess = torelease.filter((job) => job !== '-1')
      const toreleaseFailed = torelease.filter((job) => job === '-1')

      if (toreleaseSuccess.length > 0) {
        await releaseJobs(toreleaseSuccess)
      }
      if (toreleaseFailed.length > 0) {
        alert(torelease.length === 1 ? t('Failed to print file') : toreleaseFailed.length === torelease.length ? t('Failed to print all files') : t('Failed to print some files'))
      }
    } 
    if (univPrintJobs && univPrintJobs.length > 0 && Object.keys(selected).length > 0) {
      const selectedJobs = Object.values(selected).filter(job => job?.isUnivPrintJob)
      for (const job of selectedJobs) {
        await releaseUniversalPrintJob(job.id)
      }
    }
    await refresh()
    setUserPreferences(defaultPreferences)
    history.push('/release2me/jobs')
  }

  async function deleteJobs(jobs) {
    if (jobs.length > 0) {
      try {
        if (!isLoading) setIsLoading(true)
        await fetch(
          `https://${tenant.region}.release2me-service.${domain}/api/print-job/remove`,
          {
            method: 'PATCH',
            headers: {
              'Authorization': `Bearer ${jwt}`,
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ ids: jobs })
          }
        )
        await refresh()
        console.log({ Result: 'deleteJobs: success' })
        return { Result: 'deleteJobs: success' }
      } catch (e) {
        setIsLoading(false)
        console.error(e)
        return { Result: 'deleteJobs: failed', Error: e }
      }
    } else {
      console.log({ Result: 'deleteJobs: Nothing to delete' })
      return { Result: 'deleteJobs: Nothing to delete' }
    }
  }

  async function deleteUnivPrintJobs(jobs) {
    let appId = STC_ID
    if (stratus) {
      appId = STRATUS_ID
    }
    const { hash } = await getMFPHash(appId)

    if (jobs.length > 0) {
      try {
        if (!isLoading) setIsLoading(true)
        await fetch(
          `https://${tenant.region}.ms-universal-print.${domain}/api/print-jobs/device/cancel/${hash}`,
          {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${jwt}`,
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ jobs })
          }
        )
        await refresh()
        console.log({ Result: 'deleteJobs: success' })
        return { Result: 'deleteJobs: success' }
      } catch (e) {
        setIsLoading(false)
        console.error(e)
        return { Result: 'deleteJobs: failed', Error: e }
      }
    } else {
      console.log({ Result: 'deleteJobs: Nothing to delete' })
      return { Result: 'deleteJobs: Nothing to delete' }
    }
  }

  async function releaseJobs(jobs) {
    let appId = STC_ID
    if (stratus) {
      appId = STRATUS_ID
    }
    const { hash } = await getMFPHash(appId)
    if (!isLoading) setIsLoading(true)
    try {
      await fetch(
        `https://${tenant.region}.release2me-service.${domain}/api/print-job/release`,
        {
          method: 'PATCH',
          headers: {
            'Authorization': `Bearer ${jwt}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            jobs: jobs,
            keep: keep,
            serialHash: hash,
            preferences: overridePreferences ? userPreferences : undefined
          })
        }
      )
      setIsLoading(false)
      console.log({ Result: 'releaseJob: success' })
      return { Result: 'releaseJob: success' }
    } catch (e) {
      setIsLoading(false)
      console.log({ Result: 'releaseJob: failed', Error: e })
      return { Result: 'releaseJob: failed', Error: e }
    }
  }

  async function uploadPjl(job, filename, preferences = {}) {
    const pref = job.preferences

    let copies, color, finish, binding, offset, fold, collate, punchnum, layout, duplex, staple
    if (!overridePreferences) {
      copies = pref?.copies ? pref?.copies : 1
      color = pref?.color ? pref?.color : '1'
      finish = pref?.staple ? pref?.staple : ''
      staple = pref?.staple ? pref?.staple : ''
      binding = pref?.binding ? pref.binding : ''
      offset = pref?.offset === 'True'
      fold = pref?.fold ? pref.fold : ''
      collate = pref?.collate === 'True'
      punchnum = pref?.punch ? Number(pref.punch) : 0
      layout = pref?.layout ? pref.layout : ''
      duplex = pref?.layout === 'DUPLEX'
    } else {
      copies = preferences?.copies ? preferences.copies : 1
      if (preferences.color_editable) {
        color = preferences?.color ? preferences?.color : '1'
      } else {
        color = pref?.color ? pref?.color : '1'
      }
      if (preferences.staple_editable) {
        finish = preferences?.staple ? preferences?.staple : ''
        staple = preferences?.staple ? preferences?.staple : ''
      } else {
        finish = pref?.staple ? pref?.staple : ''
        staple = pref?.staple ? pref?.staple : ''
      }
      if (preferences.binding_editable) {
        binding = preferences?.binding ? preferences?.binding : ''
      } else {
        binding = pref?.binding ? pref.binding : ''
      }
      if (preferences.offset_editable) {
        offset = preferences?.offset === 'True'
      } else {
        offset = pref?.offset === 'True'
      }
      if (preferences.fold_editable) {
        fold = preferences?.fold ? preferences?.fold : ''
      } else {
        fold = pref?.fold ? pref.fold : ''
      }
      if (preferences.collate_editable) {
        collate = preferences?.collate === 'True'
      } else {
        collate = pref?.collate === 'True'
      }
      if (preferences.punch_editable) {
        punchnum = preferences?.punch ? Number(preferences?.punch) : 0
      } else {
        punchnum = pref?.punch ? Number(pref.punch) : 0
      }
      if (preferences.layout_editable) {
        layout = preferences?.layout ? preferences?.layout : ''
        duplex = preferences?.layout === 'DUPLEX'
      } else {
        layout = pref?.layout ? pref.layout : ''
        duplex = pref?.layout === 'DUPLEX'
      }
    }

    console.log('copies:', copies)
    console.log('color:', color)
    console.log('finish:', finish)
    console.log('staple:', staple)
    console.log('binding:', binding)
    console.log('offset:', offset)
    console.log('fold:', fold)
    console.log('collate:', collate)
    console.log('punchnum:', punchnum)
    console.log('layout:', layout)
    console.log('duplex:', duplex)

    const drop = job.droppoint
    const initUpload = await uploadFile(drop.id, drop.username, drop.password, filename)
    let pjl = ''

    // Staple over Offset
    if (staple === 'CORNER') {
      if (binding) {
        if (binding === 'LEFT') {
          finish = 'LEFT1POINT'
        } else if (binding === 'RIGHT') {
          finish = 'RIGHT1POINT'
        }
      }
      offset = false
    } else if (finish === 'ANY2POINT') {
      offset = false
    }

    // FOLD over Staple, Punch, Collate, and Offset
    if (fold) {
      finish = 'NONE'
      collate = true
      offset = false
      punchnum = 0
    }

    // Booklet has highest priority
    if (layout === 'BOOKLET4IN1') {
      fold = 'CENTERFOLDIN'
      finish = 'CENTER'
      collate = true
      punchnum = 0
      duplex = true
    } else if (duplex) {
      layout = 'NORMAL'
      duplex = true
    }

    pjl = pjl + (`@PJL SET JOBNAME=${job.name}\n`)

    if (copies > 0) {
      if (collate) {
        pjl = pjl + (`@PJL SET QTY=${copies}\n`)
      } else {
        pjl = pjl + (`@PJL SET COPIES = ${copies}\n`)
      }
    }
    if (punchnum > 0) {
      pjl = pjl + (`@PJL SET PUNCHNUM=${punchnum}\n`)
      pjl = pjl + (`@PJL SET PUNCH=ON\n`)
    } else {
      pjl = pjl + (`@PJL SET PUNCH=OFF\n`)
    }
    if (offset) {
      pjl = pjl + (`@PJL SET JOBOFFSET=ON\n`)
    } else {
      pjl = pjl + (`@PJL SET JOBOFFSET=OFF\n`)
    }
    if (binding) pjl = pjl + (`@PJL SET BINDING=${binding}\n`)
    if (finish) pjl = pjl + (`@PJL SET FINISH=${finish}\n`)
    if (fold) pjl = pjl + (`@PJL SET FOLDING=${fold}\n`)
    if (layout) pjl = pjl + (`@PJL SET LAYOUT=${layout}\n`)
    if (duplex) pjl = pjl + (`@PJL SET DUPLEX=ON\n`)

    pjl = pjl + (`@PJL SET PLANESINUSE = ${color}\n`)
    if (pref.headers.length > 0 && !overridePreferences) {
      pref.headers.forEach((item) => {
        if (!(item.active ?? true) || !(item.defaultEnabled ?? true)) {
          return
        }
        pjl = pjl + (`@PJL SET ${item.name.toUpperCase()} = ${item.value.toUpperCase()}\n`)
      })
    }
    if (preferences.pjlHeadersMap && overridePreferences) {
      [...preferences.pjlHeadersMap.values()].forEach((header) => {
        if (header.enabled) {
          pjl += `@PJL SET ${header.name.toUpperCase()} = ${header.value.toUpperCase()}\n`
        }
      })
    }

    console.log('PJL:', pjl)

    await axios({
      method: 'put',
      url: initUpload.data.info.url,
      headers: {
        ...initUpload.data.info.headers,
      },
      data: pjl,
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
    })
    return pjl
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = [optimizedJobs, univPrintJobs].flat().reduce((prev, curr) => {
        if (curr.id !== undefined) {
          const nextState = {
            ...prev,
            [curr.id]: {
              id: curr.id,
              isUnivPrintJob: curr?.isUnivPrintJob ?? false
            }
          }
          return nextState
        }
        return prev
      }, {})
      setSelected(newSelected);
      return
    }
    setSelected({});
  }

  const handleSelectClick = async (event, row) => {
    const rowId = row.id
    const selectedJob = selected[rowId]
    if (selectedJob === undefined) {
      const currSelections = {
        ...selected,
        [rowId]: {
          id: rowId,
          isUnivPrintJob: row?.isUnivPrintJob ?? false
        }
      }
      setSelected(currSelections)
    } else {
      const currSelections = Object.entries(selected)
      const filter = currSelections.reduce((prev, [key, value]) => {
        if (value.id !== row.id) {
          return {
            ...prev,
            [key]: {
              id: key,
              ...value
            }
          }
        }
        return prev
      }, {})
      setSelected(filter)
    }
  }

  const redirect = () => { history.push('/') }
  const logout = () => {
    history.replace({ ...history.location, state: undefined });
    history.push('/logout')
  }

  return (
    <React.Fragment>
      <Header user={user} tenant={tenant.name} logout={logout} redirect={redirect} noDipa={true} loading={false} />
      <ThemeProvider theme={theme}>
        <ScopedCssBaseline />
        <div>
          <Toolbar
            search={search}
            setSearch={setSearchString}
            applySearch={applySearch}
            printJobs={printJobs}
            deleteJobs={deleteJobs}
            deleteUnivPrintJobs={deleteUnivPrintJobs}
            refresh={refresh}
            selected={selected}
            optimizedJobs={optimizedJobs}
            distinctQueues={distinctQueues}
            pinnedQueue={pinnedQueue}
            setPinnedQueue={setPinnedQueue}
            openDeleteDialog={openDeleteDialog}
            setOpenDeleteDialog={setOpenDeleteDialog}
            keep={keep}
            setKeep={setKeep}
            openPrintSettingsDialog={openPrintSettingsDialog}
            setOpenPrintSettingsDialog={setOpenPrintSettingsDialog}
            redirectToPrintSettings={redirectToPrintSettings}
            setOverridePreferences={setOverridePreferences}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        </div>
        <div>
          <Switch>
            <Route path={`${path}/jobs`}>
              {
                isLoading ?
                  <Loading />
                  :
                  <PrintJobs
                    jobs={jobs}
                    univPrintJobs={univPrintJobs}
                    queues={queues}
                    optimizedJobs={optimizedJobs}
                    handleSelectAllClick={handleSelectAllClick}
                    handleSelectClick={handleSelectClick}
                    selected={selected}
                    pinnedQueue={pinnedQueue}
                  />
              }

            </Route>
            <Route path={`${path}/settings`}>
              <PrintSettings
                userPreferences={userPreferences}
                setUserPreferences={setUserPreferences}
                selected={selected}
                optimizedJobs={optimizedJobs}
              />
            </Route>
          </Switch>
        </div>
      </ThemeProvider>
    </React.Fragment>
  )
}
